import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import PurchaseHistoryList from "../../components/PurchaseHistory/PurchaseHistoryList";

const PurchaseHistoryPage = () => {
  return (
    <div className="px-3 py-2">
      <Breadcrumb currentPage="Purchase Histories" />
      <PurchaseHistoryList />
    </div>
  );
};

export default PurchaseHistoryPage;
